module.exports = __webpack_public_path__ + "static/media/Tischdecke_140x240.2cbc1a60.png";